import classNames from "classnames";

import { FC, PropsWithChildren } from "react";
import styles from "./FlexContent.module.css";

type FlexContentProps = PropsWithChildren<{
  padding?: boolean;
  noPaddingTop?: boolean;
  direction?: "row" | "column";
}>;

const FlexContent: FC<FlexContentProps> = ({
  children,
  padding = false,
  noPaddingTop = false,
  direction = "column",
}: FlexContentProps) => (
  <div
    className={classNames(styles.content, {
      [styles.padding]: padding,
      [styles.noPaddingTop]: noPaddingTop,
      [styles.row]: direction == "row",
      [styles.column]: direction == "column",
    })}
  >
    {children}
  </div>
);

export default FlexContent;
